import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	title: {
		id: 'navigation-apps-sidebar-plan.menu.header.nudge.title',
		defaultMessage: 'A new menu for you',
		description: 'Title. Show in spotlight.',
	},
	description: {
		id: 'navigation-apps-sidebar-plan.menu.header.nudge.description',
		defaultMessage:
			"We've moved the plan management options to this menu. Select this to do things like duplicate or archive your plan.",
		description: 'Body text. Show in spotlight.',
	},
	dismiss: {
		id: 'navigation-apps-sidebar-plan.menu.header.nudge.dismiss',
		defaultMessage: 'OK',
		description: 'Spotlight action, ends the spotlight nudge.',
	},
});
